import * as React from "react";
import { Loader2 } from "lucide-react";

import { cn } from "../../lib/utils";

const Spinner = React.forwardRef(
  ({ className, size = "default", ...props }, ref) => {
    const sizeClasses = {
      sm: "h-6 w-6",
      default: "h-8 w-8",
      lg: "h-12 w-12",
      xl: "h-16 w-16",
      "2xl": "h-20 w-20",
    };

    return (
      <Loader2
        ref={ref}
        className={cn("animate-spin", sizeClasses[size], className)}
        {...props}
      />
    );
  }
);
Spinner.displayName = "Spinner";

export { Spinner };
